import React from "react";
import PropTypes from "prop-types";

import { apolloClient } from "js/apollo/apollo-client";
import useIconDownload from "frontend/hooks/useIconDownload";
import {
    BASIC_COPY_SIZE,
    PRO_COPY_SIZE,
    DEFAULT_DOWNLOAD_TYPE,
    DOWNLOAD_TYPES
} from "frontend/components/icons/helpers";

function DownloadIconLink({
    iconId,
    type = DEFAULT_DOWNLOAD_TYPE,
    isPro = false
}) {
    const { startDownload } = useIconDownload({
        icon: { id: iconId },
        downloadType: type,
        downloadSize: isPro ? PRO_COPY_SIZE : BASIC_COPY_SIZE,
        client: apolloClient
    });
    // Styled with sass because this link is only used by legacy screens
    return <button onClick={startDownload}>Download {type} Icon</button>;
}

DownloadIconLink.propTypes = {
    iconId: PropTypes.string.isRequired,
    type: PropTypes.oneOf(DOWNLOAD_TYPES),
    isPro: PropTypes.bool
};

export default DownloadIconLink;
